import { createEntityAdapter } from '@reduxjs/toolkit';

import type { IFileItem } from '@wix/social-groups-serverless/dist/files/types';

export const filesItemsAdapter = createEntityAdapter<IFileItem>({
  selectId: (item) => item.src?.id as string,
});

export const selectors = filesItemsAdapter.getSelectors();
